import { Sounds } from '../../sounds';
import { TutorialSteps } from '../../prefabs/game/Tutorial';
import {Level, LevelMapName, LevelName} from './level';

export const Level5: Level = {
  id:LevelName.Level5,
  //smash levels are how many crates need to be smashed to reach X star goals
  smashLevels:{
    smashLevels: [40,70,100]
  },
  //target score is how many crates need to be smashed to unlock the next level
  targetScore:40,
  levelMap:LevelMapName.Level5,
  levelBackground:"bg-country.jpg",
  gameplayBackground:"gameplay-country.png",
  levelBackgroundAtlas:"game-country",
  friction:0.99,
  lives: 3,
  bumperDownKey:"bumper-down-country.png",
  tutorialStep:[TutorialSteps.None],
  arrowColor:0x233533,
  bgMusic:Sounds.Track.CountryMusicLoop
}
